import React from 'react';
import { HStack, Icon, Text } from '@chakra-ui/react';
import { FiAlertCircle, FiCheckCircle, FiClock, FiRefreshCw, FiSearch, FiUploadCloud } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';

const meta: Record<string, { icon: React.ElementType; bg: string; color: string }> = {
    completed: { icon: FiCheckCircle, bg: 'green.50', color: 'green.600' },
    failed: { icon: FiAlertCircle, bg: 'red.50', color: 'red.600' },
    in_progress_auto: { icon: FiRefreshCw, bg: 'blue.50', color: 'blue.600' },
    in_progress_manual: { icon: FiSearch, bg: 'purple.50', color: 'purple.600' },
    upload: { icon: FiUploadCloud, bg: 'yellow.100', color: 'yellow.700' },
    waiting: { icon: FiClock, bg: 'orange.50', color: 'orange.600' },
};

const KycStatusBadge: React.FC<{ status?: string; canUpload: boolean; notRequired: boolean }> = ({
    status,
    canUpload,
    notRequired,
}) => {
    const { t } = useTranslation();
    const key = notRequired
        ? 'notRequired'
        : status === 'wait_user'
          ? canUpload
              ? 'upload'
              : 'waiting'
          : status || 'waiting';
    const style = meta[key] || meta.waiting;
    const label = t.kyc.statuses[key as keyof typeof t.kyc.statuses] || t.kyc.statuses.waiting;
    return (
        <HStack gap={2} px={3} py={1} bg={style.bg} color={style.color} flexShrink={0} alignSelf="flex-start">
            <Icon as={style.icon} boxSize={4} />
            <Text fontSize="sm" fontWeight="medium">
                {label}
            </Text>
        </HStack>
    );
};
export default KycStatusBadge;
